<div class="flex justify-center items-center gap-1 mt-1">
    <div class="w-1.5 h-1.5 rounded-full animate-subtle-bounce [animation-delay:-0.32s] {{color}}"></div>
    <div class="w-1.5 h-1.5 rounded-full animate-subtle-bounce [animation-delay:-0.16s] {{color}}"></div>
    <div class="w-1.5 h-1.5 rounded-full animate-subtle-bounce {{color}}"></div>
</div>